import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const CameraIcon = ({
  color = '#8CA4C9',
  size = 25,
  id = 'camera-icon',
  ...props
}) => (
  <svg width={size} viewBox="0 0 36 36" {...props}>
    <defs>
      <path
        d="M12.857 0h10.286l2.571 4.286H10.286L12.857 0zm-9 5.143h28.286A3.85 3.85 0 0 1 36 9v17.143A3.85 3.85 0 0 1 32.143 30H3.857A3.85 3.85 0 0 1 0 26.143V9a3.85 3.85 0 0 1 3.857-3.857zM18 7.714c-5.434 0-9.857 4.423-9.857 9.857 0 5.435 4.423 9.858 9.857 9.858 5.434 0 9.857-4.423 9.857-9.858 0-5.434-4.423-9.857-9.857-9.857zM30.429 9a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572zM18 9.429a8.13 8.13 0 0 1 8.143 8.142A8.13 8.13 0 0 1 18 25.714a8.13 8.13 0 0 1-8.143-8.143A8.13 8.13 0 0 1 18 9.43zm0 2.142a6 6 0 1 0 .002 12.002A6 6 0 0 0 18 11.571z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path fill={color} mask={`url(#${id}-b)`} d="M-5-5h46v40H-5z" />
    </g>
  </svg>
);

CameraIcon.propTypes = propTypes;

export default CameraIcon;
